import AppBarAdmin from "../../components/AppBarAdmin";
import CustomDivider from "../../components/CustomDivider";
import Kanban from "../../components/Kanban";

export default function Gerenciamento(){
    return (
        <>
            <AppBarAdmin title="Minhas Solicitações" />
            <CustomDivider />
            <Kanban />
        </>
    )
}